/** @format */

import { request } from '@power/runtime-vue3';

export type Request = {
	bussinessName?: string;
	code?: string;
};

export type Response = {
	code: number;
	rows: {
		code: string;
		bussinessName: string;
		dataTableName: string;
		remark: string;
		objectid: string;
		canTableNameEdit: '0' | '1';
		canDel: '0' | '1';
		relationCompute: '0' | '1';
		ifContrast: '0' | '1';
		ifRecordHis: '0' | '1';
		ifSandBox: '0' | '1';
	}[];
	total: number;
};

// 获取路由
export const getBussinessList = (params: Request = {}) => {
	return request<Response>(
		{
			url: '/power-model/bussiness/list',
			method: 'get',
			params,
		},
		{ isGetDataDirectly: false },
	);
};

export const getInfoByCode = (params) => {
	return request<any>({
		url: `/power-model/subscribe/getInfoByCode`,
		method: 'post',
		params,
	});
};

export const getFieldsByCode = (data) => {
	return request<any>({
		url: '/power-model/subscribe/getFieldsByCode',
		method: 'post',
		data,
	});
};

export const getDataByCode = (data) => {
	return request<any>(
		{
			url: '/power-model/subscribe/service/query/data',
			method: 'post',
			data,
		},
		{ isGetDataDirectly: false },
	);
};
